import type { ZodError } from 'zod';
import { fromZodError } from 'zod-validation-error';

import { logWithSentry, SentryErrorKind } from 'scripts/initSentry';

import { captureException } from './captureException';

/**
 * Показывает ошибку валидации zod в более удобочитаемом формате (поле `normalized`)
 */
export const logZodError = (error: ZodError): void => {
  try {
    const normalized = fromZodError(error).toString();

    captureException(error, 'zod', { normalized });
  } catch (e) {
    logWithSentry(e, SentryErrorKind.normalization);
    captureException(e, 'zod', error);
  }
};
